import { useQuery } from "@tanstack/react-query";
import { getSearchTerms } from "src/api/search";
const defaultTerms = {
    subject: null,
    placeHolder: "찾고 싶은 자료를 검색해보세요",
    terms: []
};
/**
 * 추천 검색어 API 훅
 * 과목별 추천 검색어 목록을 가져옴
 */ export const useRecommendSearchTerms = (selectedSubject)=>{
    const { data: getSearchTermsResponse  } = useQuery([
        "getSearchTerms"
    ], getSearchTerms);
    const recommendSearchTermList = (getSearchTermsResponse === null || getSearchTermsResponse === void 0 ? void 0 : getSearchTermsResponse.termItems.find((item)=>{
        return (item === null || item === void 0 ? void 0 : item.subject) === selectedSubject;
    })) || defaultTerms;
    return {
        recommendSearchTermList
    };
};
